/* eslint-disable @typescript-eslint/no-confusing-void-expression */
import React, {useState, useEffect} from 'react';
import {Card, Col, Container, Dropdown, Row, Form} from 'react-bootstrap';
import TableContainer from 'Common/TableContainer';
import ApiUtils from 'api/ApiUtils';
import {toast} from 'react-toastify';
import ModalContainer from 'Common/ModalContainer';
import {DOCUMENT_TITLE} from 'Common/constants/layout';
import Swal from 'sweetalert2';
import {variables} from 'utils/constant';
import {useDispatch, useSelector} from 'react-redux';
import {setProductIds} from 'slices/statusChange/reducer';
import {changeStatus} from 'slices/thunk';
import EventForm from './EventForm';
import moment from 'moment';
import Select, {type MultiValue} from 'react-select';
import customStyles from 'Common/customStyles';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slick from 'react-slick';
const SlickSlider: any = Slick;

interface CategoryItemType {
  data: {
    data: [];
    total: number;
  };
  display_header_count: number;
  display_home_count: number;

  message: string;
}

const Events = (): JSX.Element => {
  document.title = DOCUMENT_TITLE.HISTORYEVENTS;
  const [modalFlag, setModalFlag] = useState<boolean>(false);
  const [editEvent, setEditEvent] = useState<any>({});
  const [isEditCatergory, setIsEditCategory] = useState(false);
  const [iseAddCategory, setIsAddCategory] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [sortColumn, setSortColumn] = useState('id');
  const [search, setSearch] = useState<string>('');
  const [sortDirection, setSortDirection] = useState('desc');
  console.log('🚀 ~ Events ~ setSortDirection:', setSortDirection);
  const [eventList, setEventList] = useState<CategoryItemType>();
  const [venueList, setVenueList] = useState([]);
  const [filter, setFilter] = useState<{
    venue: Array<{value: string; label: string}>;
  }>({venue: []});

  const defaultPage = 1;
  const [pageSize, setPageSize] = useState(50);
  const [pageValue, setPageValue] = useState(defaultPage);
  const [totalRecords, setTotalRecords] = useState(defaultPage);

  const currentData = Math.ceil(totalRecords / pageSize);
  const [allChecked, setAllChecked] = useState(false);
  // const [selectedCheckboxes, setSelectedCheckboxes] = useState<string[]>([]);
  const [selectedProductIds, setSelectedProductIds] = useState<number[]>([]);
  const [isCheckboxChanged, setIsCheckboxChanged] = useState(false);
  const dispatch = useDispatch<any>();
  const [isStatusChange, setisStatusChange] = useState(false);

  const [Checked, seChecked] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [resetSearchFlag, setResetSearchFlag] = useState(false);

  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [modalVideoUrl, setModalVideoUrl] = useState('');
  const [eventImages, setEventImages] = useState<any>([]);

  const mappedFilter = filter?.venue?.map((venue: any) => venue?.value);
  const [isImage, setIsImage] = useState('');

  const {Layout}: any = useSelector(state => state);
  const [isDark, setIsDark] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [currentIndex, setCurrentIndex] = useState(0);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: currentIndex,
    autoplay: false, // Enables auto-slide
    autoplaySpeed: 3000, // Changes slide every 3 seconds
    pauseOnHover: true, // Pauses when hovering over the slider
    fade: true, // Adds a fade effect for the slide transition
  };
  useEffect(() => {
    if (Layout.layoutModeType === 'dark') {
      setIsDark(true);
    } else if (Layout.layoutModeType === 'light') {
      setIsDark(false);
    } else {
      setIsDark(false);
    }
  }, [Layout.layoutModeType]);
  const handleVideoClick = (
    videoUrl: string,
    Type: string = 'video',
    images: any,
  ): void => {
    setModalVideoUrl(videoUrl);
    setIsVideoModalOpen(true);
    setIsImage(Type);
    setEventImages(images);
  };

  const closeModal = (): void => {
    setIsVideoModalOpen(false);
    setModalVideoUrl('');
    setIsImage('');
    setEventImages([]);
  };

  useEffect(() => {
    ApiUtils.getEventList(
      `?page=${pageValue}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${search}&type=history`,
      mappedFilter,
    )
      .then(async (data: any): Promise<void> => {
        setEventList(data as CategoryItemType);
        setTotalRecords(data?.total);
      })
      .catch((error: any) => {
        toast.error(error.message);
      });

    setisStatusChange(false);
    setAllChecked(false);
  }, [
    pageValue,
    isEditCatergory,
    iseAddCategory,
    pageSize,
    search,
    isStatusChange,
    filter,
  ]);

  // Add a new function to handle normal search
  const handleSearch = (value: string): void => {
    setSearch(value);
    setPageValue(defaultPage);
  };
  const handleNextPagination = (pageSize: any): void => {
    if (currentData > 0 && currentData > pageSize) {
      setPageValue(pageSize + 1);
    }
  };
  const handlePrevPagination = (pageSize: any): void => {
    if (pageSize > 1 && currentData >= pageSize) {
      setPageValue(pageSize - 1);
    }
  };

  const toggleCategoryStatus = async (
    // originalPayload: Record<string, any>,
    id: number,
    statusId: number,
    guestStatus: number,
    bookingStatus: number,
  ): Promise<void> => {
    try {
      // Implement logic to toggle category status
      const paylaod = {
        id,
        status: statusId,
        guest_status: guestStatus,
        booking_status: bookingStatus,
      };

      await ApiUtils.updateEventStatus({...paylaod});

      ApiUtils.getEventList(
        `?page=${pageValue}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${search}&type=history`,
        mappedFilter,
      )
        .then(async (data: any): Promise<void> => {
          toast.success('Status updated successfully!!');
          setEventList(data as CategoryItemType);
          setTotalRecords(data?.total);
        })
        .catch((error: any) => {
          toast.error(error.message);
        });
    } catch (error) {
      console.error('Error toggling category status:', error);
    }
  };

  useEffect(() => {
    if (allChecked) {
      const allIds: any = eventList?.data?.data?.map(
        (item: {id: any}) => item.id,
      ); // Select all by their IDs
      setSelectedProductIds(allIds);
    } else {
      if (!Checked) {
        setSelectedProductIds([]);
      }
    }
  }, [allChecked, eventList]);

  useEffect(() => {
    dispatch(setProductIds(selectedProductIds));
    if (selectedProductIds.length > 0) {
      setIsCheckboxChanged(true);
    } else {
      setIsCheckboxChanged(false);
    }
    const categorylength: any = eventList?.data?.data?.length;

    if (selectedProductIds.length === categorylength) {
      setAllChecked(true);
      seChecked(false);
    }
    if (selectedProductIds.length < categorylength) {
      setAllChecked(false);
      seChecked(true);
    }
  }, [selectedProductIds]);

  const productIds = useSelector(
    (state: any) => state.statusChange.setProductids,
  );
  const setproductstatus = async (e: any): Promise<void> => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Want to change status for selected Events',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    });
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (result.isConfirmed) {
      dispatch(changeStatus(e.target.value, productIds, 'category'));
      setisStatusChange(true);
    }
  };
  useEffect(() => {
    setAllChecked(false);
    setSelectedProductIds([]);
  }, [isStatusChange]);
  const columns = [
    {
      Header: 'Image',
      disableFilters: true,
      filterable: true,
      accessor: 'file', // Assuming 'image' is the property in your data for the image URL
      Cell: ({cell}: any) => {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        const eventImages = cell?.row?.original?.event_image || [];
        const sortedImages = eventImages.sort(
          (a: any, b: any) => a.sort_order - b.sort_order,
        );
        // Get the minimum sort_order value
        const minSortOrder = Math.min(
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          ...eventImages.map((file: any) => file.sort_order || Infinity),
        );

        // Find the file with the minimum sort_order
        const minSortOrderItem = eventImages.find(
          (file: any) => file.sort_order === minSortOrder,
        );

        return (
          <React.Fragment>
            {(() => {
              // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
              if (!minSortOrderItem?.name) {
                return <span>-</span>; // Handle cases where no valid item exists
              }
              const file = minSortOrderItem.name;
              const isImage = /\.(jpg|jpeg|png|gif|bmp|svg|webp)$/i.test(file);
              const isVideo = /\.(mp4|webm|ogg|mov|avi|flv|mkv)$/i.test(file);

              if (isImage) {
                return (
                  <img
                    src={file}
                    width={60}
                    height={60}
                    alt="Player"
                    onClick={() =>
                      handleVideoClick(file, 'image', sortedImages)
                    }
                  />
                );
              } else if (isVideo) {
                return (
                  <div
                    style={{
                      cursor: 'pointer',
                      fontSize: '24px',
                      color: 'white',
                      backgroundColor: 'black',
                      padding: '10px',
                      textAlign: 'center',
                      // borderRadius: '100%',
                    }}
                    onClick={() =>
                      handleVideoClick(file, 'video', sortedImages)
                    }>
                    ▶
                  </div>
                );
              } else {
                return '-';
              }
            })()}
          </React.Fragment>
        );
      },
    },
    {
      Header: 'Venue Name',
      disableFilters: true,
      filterable: true,
      accessor: 'venue',
      Cell: (cellProps: any) => {
        return cellProps?.value?.name;
      },
    },
    {
      Header: 'Event Name',
      disableFilters: true,
      filterable: true,
      accessor: 'event_name',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },
    {
      Header: 'Main Artist name',
      disableFilters: true,
      filterable: true,
      accessor: 'main_artist_name',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },
    {
      Header: 'Other Artist Name',
      disableFilters: true,
      filterable: true,
      accessor: 'other_artist_name',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },

    {
      Header: 'Event Date',
      disableFilters: true,
      filterable: true,
      accessor: 'date_time',
      Cell: (cellProps: any) => {
        return moment(cellProps.value).format('Do MMM, YYYY hh:mm A');
      },
    },
    {
      Header: 'Guest list close time',
      disableFilters: true,
      filterable: true,
      accessor: 'guest_close_date_time',
      Cell: (cellProps: any) => {
        return moment(cellProps.value).format('Do MMM, YYYY hh:mm A');
      },
    },
    {
      Header: 'Address',
      disableFilters: true,
      filterable: true,
      accessor: 'address',
      Cell: (cellProps: any) => {
        return <div className="cuisine-cell">{cellProps.value}</div>;
      },
    },
    {
      Header: 'Status',
      disableFilters: true,
      filterable: true,
      accessor: 'status',

      Cell: (cellProps: any) => {
        // console.log('🚀 ~ cellProps:', cellProps.row.original.guest_status);
        const isActive = cellProps.value === variables.EVENT_ACTIVE_STATUS_ID;
        const newStatusId =
          cellProps.value === variables.EVENT_ACTIVE_STATUS_ID
            ? variables.EVENT_INACTIVE_STATUS_ID
            : variables.EVENT_ACTIVE_STATUS_ID;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const toggleStatus = async (): Promise<void> => {
          await toggleCategoryStatus(
            // cellProps?.cell?.row?.original, // Orignal object record
            cellProps?.cell?.row?.original?.id,
            newStatusId, // Status
            cellProps?.cell?.row?.original?.guest_status, // Guest status
            cellProps?.cell?.row?.original?.booking_status, // Booking status
          );
        };

        return (
          <div className="form-check form-switch d-flex">
            {/* <Form.Check
              type="checkbox"
              role="switch"
              id="flexSwitchCheckChecked"
              onChange={toggleStatus}
              checked={isActive}
              className="form-switch-md"
              disabled
            /> */}
            <div>
              <Form.Label htmlFor="flexSwitchCheckChecked">
                {isActive
                  ? variables.CATEGORY_ACTIVE_STATUS
                  : variables.CATEGORY_INACTIVE_STATUS}
              </Form.Label>
            </div>
          </div>
        );
      },
    },

    {
      Header: 'Guest List Status',
      disableFilters: true,
      filterable: true,
      accessor: 'guest_status',

      Cell: (cellProps: any) => {
        const isActive = cellProps.value === variables.EVENT_ACTIVE_STATUS_ID;
        const newStatusId =
          cellProps.value === variables.EVENT_ACTIVE_STATUS_ID
            ? variables.EVENT_INACTIVE_STATUS_ID
            : variables.EVENT_ACTIVE_STATUS_ID;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const toggleStatus = async (): Promise<void> => {
          await toggleCategoryStatus(
            // cellProps?.cell?.row?.original, // Orignal object record
            cellProps?.cell?.row?.original?.id,
            cellProps?.cell?.row?.original?.status, // Status
            newStatusId, // Guest status
            cellProps?.cell?.row?.original?.booking_status, // Booking status
          );
        };

        return (
          <div className="form-check form-switch d-flex">
            {/* <Form.Check
              type="checkbox"
              role="switch"
              id="flexSwitchCheckChecked"
              onChange={toggleStatus}
              checked={isActive}
              className="form-switch-md"
              disabled
            /> */}
            <div>
              <Form.Label htmlFor="flexSwitchCheckChecked">
                {isActive
                  ? variables.CATEGORY_ACTIVE_STATUS
                  : variables.CATEGORY_INACTIVE_STATUS}
              </Form.Label>
            </div>
          </div>
        );
      },
    },
    {
      Header: 'Booking List Status',
      disableFilters: true,
      filterable: true,
      accessor: 'booking_status',

      Cell: (cellProps: any) => {
        const isActive = cellProps.value === variables.EVENT_ACTIVE_STATUS_ID;
        const newStatusId =
          cellProps.value === variables.EVENT_ACTIVE_STATUS_ID
            ? variables.EVENT_INACTIVE_STATUS_ID
            : variables.EVENT_ACTIVE_STATUS_ID;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const toggleStatus = async (): Promise<void> => {
          await toggleCategoryStatus(
            // cellProps?.cell?.row?.original, // Orignal object record
            cellProps?.cell?.row?.original?.id,
            cellProps?.cell?.row?.original?.status, // Status
            cellProps?.cell?.row?.original?.guest_status, // Guest status
            newStatusId, // Booking status
          );
        };

        return (
          <div className="form-check form-switch d-flex">
            {/* <Form.Check
              type="checkbox"
              role="switch"
              id="flexSwitchCheckChecked"
              onChange={toggleStatus}
              checked={isActive}
              className="form-switch-md"
              disabled
            /> */}
            <div>
              <Form.Label htmlFor="flexSwitchCheckChecked">
                {isActive
                  ? variables.CATEGORY_ACTIVE_STATUS
                  : variables.CATEGORY_INACTIVE_STATUS}
              </Form.Label>
            </div>
          </div>
        );
      },
    },

    {
      Header: 'Action',
      disableFilters: true,
      filterable: true,
      accessor: (cellProps: any) => {
        return (
          <Dropdown className="text-start">
            <Dropdown.Toggle className="btn btn-ghost-primary btn-icon btn-sm arrow-none">
              <i className="mdi mdi-dots-horizontal" />
            </Dropdown.Toggle>
            <Dropdown.Menu as="ul" className="dropdown-menu-end">
              <li>
                <Dropdown.Item
                  onClick={() => {
                    setEditEvent(cellProps);
                    modalToggle();
                  }}>
                  <i className="ri-pencil-fill align-bottom me-2 text-muted" />{' '}
                  View
                </Dropdown.Item>
              </li>
            </Dropdown.Menu>
          </Dropdown>
        );
      },
    },
  ];

  function modalToggle(): void {
    setModalFlag(!modalFlag);
  }

  useEffect(() => {
    ApiUtils.getVenueList(
      `?page=${pageValue}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${search}&type=dropDown`,
    )
      .then(async (data: any): Promise<void> => {
        const mappedData = data?.map((data: any) => {
          return {value: data.id, label: data.name};
        });
        setVenueList(mappedData);
      })
      .catch((error: any) => {
        toast.error(error.message);
      });
    // void fetchStatus();
    setisStatusChange(false);
    setAllChecked(false);
  }, []);

  const handleSelectVenueChange = (
    selectedOptions: MultiValue<{value: string; label: string}>,
  ): void => {
    setFilter({venue: [...selectedOptions]}); // Convert read-only array to mutable array
  };
  const isImageOrVideo = (fileName: any): string => {
    const ext = fileName?.split('.').pop().toLowerCase();
    return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(ext)
      ? 'image'
      : ['mp4', 'avi', 'mov', 'mkv', 'webm', 'ogg', 'flv'].includes(ext)
        ? 'video'
        : 'unknown';
  };
  return (
    <>
      <div className="page-content">
        <Container fluid={true}>
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">Events History</h4>
          </div>
          <div id="couponsList">
            <Row>
              <Col lg={12}>
                <Card>
                  <Card.Body className="bg-soft-light border border-dashed border-start-0 border-end-0">
                    <Form>
                      <Row className="g-3 justify-content-between align-items-center">
                        <Col lg={4}>
                          <div
                            aria-labelledby="category-name-label"
                            className="mb-3">
                            <Form.Label
                              id="category-name-label"
                              htmlFor="category-name">
                              Venue
                            </Form.Label>
                            <Select
                              isMulti
                              className="custom-select"
                              id="venue-name"
                              name="venue-name"
                              value={filter.venue}
                              onChange={handleSelectVenueChange}
                              styles={isDark ? customStyles : {}}
                              options={venueList}></Select>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <Card>
                  <Card.Body>
                    <TableContainer
                      columns={columns ?? []}
                      data={eventList?.data ?? []}
                      iscustomPageSize={false}
                      handleNextPagination={handleNextPagination}
                      handlePrevPagination={handlePrevPagination}
                      pageValue={pageValue}
                      isBordered={true}
                      customPageSize={pageSize}
                      isGlobalFilter={true}
                      pageSize={pageSize}
                      currentData={currentData}
                      setPageSize={setPageSize}
                      className="custom-header-css"
                      tableClass="table-centered align-middle table-nowrap mb-0"
                      theadClass="text-muted table-light"
                      SearchPlaceholder="Search Events..."
                      onClick={() => {
                        setEditEvent({});
                        modalToggle();
                      }}
                      // sortColumn={sortColumn}
                      // sortDirection={sortDirection}
                      // handleSortByColumn={handleSortByColumn}
                      onSearch={handleSearch}
                      isChangeStatus={isCheckboxChanged}
                      isCategory={true}
                      statusClickevent={setproductstatus}
                      resetSearchFlag={resetSearchFlag}
                    />
                    <div className="noresult" style={{display: 'none'}}>
                      <div className="text-center">
                        <h5 className="mt-2">Sorry! No Result Found</h5>
                        <p className="text-muted mb-0">
                          We've searched more than 150+ Orders We did not find
                          any events for you search.
                        </p>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>

          <ModalContainer
            showModal={modalFlag}
            handleClose={modalToggle}
            modalTitle={editEvent.id !== undefined ? 'View Event' : 'Add Event'}
            modalBody={
              <>
                <EventForm
                  handleClose={modalToggle}
                  editEvent={editEvent}
                  setIsEditCategory={setIsEditCategory}
                  setIsAddCategory={setIsAddCategory}
                />
              </>
            }
          />

          {/* <ModalContainer
            showModal={isVideoModalOpen}
            handleClose={closeModal}
            modalTitle="Event Video"
            modalBody={
              <>
                <video width="100%" height="auto" controls>
                  <source src={modalVideoUrl} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </>
            }
          /> */}

          <ModalContainer
            showModal={isVideoModalOpen}
            handleClose={closeModal}
            size="md"
            isTemplate={true}
            modalTitle={
              eventImages?.length === 1
                ? isImage === 'image'
                  ? 'Event Image'
                  : 'Event Video'
                : 'Event Image/Video'
            }
            modalBody={
              <>
                {eventImages?.length > 1 ? (
                  <SlickSlider {...settings}>
                    {eventImages?.map(
                      (
                        image: {
                          id: React.Key | null | undefined;
                          name: string | undefined;
                          image_name: string | undefined;
                        },
                        index: any,
                      ) => (
                        <div key={image.id}>
                          {isImageOrVideo(image.name) === 'image' ? (
                            <img
                              src={image.name}
                              alt={image.image_name}
                              className="modal-image-preview"
                            />
                          ) : (
                            <video controls className="modal-image-preview">
                              <source src={image.name} type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                          )}
                        </div>
                      ),
                    )}
                  </SlickSlider>
                ) : (
                  <>
                    {isImage === 'image' ? (
                      <img
                        src={modalVideoUrl}
                        alt="Event"
                        className="modal-image-preview"
                      />
                    ) : (
                      <video controls className="modal-image-preview">
                        <source src={modalVideoUrl} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    )}
                  </>
                )}
              </>
            }
          />
        </Container>
      </div>
    </>
  );
};

export default Events;
